import React from "react";
import { PALETTE } from "../../common/ThemeConstants";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { IoMdClose } from "react-icons/io";

export default function CardAdminPlanDay({
  planDay,
  height = 100,
  onDeleteCallback,
}) {
  return (
    <div
      className="my-2 shadow-sm rounded-md"
      style={{
        border: "solid 0px",
        backgroundColor: PALETTE.WHITE,
        cursor: "pointer",
      }}
    >
      <Row className="g-0 align-items-center" style={{ width: "100%" }}>
        <Col xs={4} className="align-self-center text-start p-1">
          <img
            className="rounded-md"
            style={{
              objectFit: "cover",
              maxHeight: height,
              width: "auto",
              maxWidth: "100%",
            }}
            src={planDay.workout.cover}
            alt={planDay.workout.name}
          />
        </Col>
        <Col xs={6} className="text-start" style={{ paddingLeft: "4px" }}>
          <p className="cardDescription" style={{ marginBottom: "2px" }}>
            {planDay.workout.name}
          </p>
        </Col>
        <Col xs={2} className="align-self-center text-end px-3">
          <IoMdClose size={25} color={PALETTE.GRAY} style={{ cursor: "pointer" }}
            onClick={onDeleteCallback}
          />
        </Col>
      </Row>
    </div>
  );
}
